module.exports = __webpack_public_path__ + "static/media/mountain_biking_640.f0e2f60e.jpg";